import React from 'react'

import { Grid } from '@mui/material'
import debounce from 'lodash/debounce'
import pick from 'lodash/pick'

import { FormSelect, FormTextField } from 'components/input'
import { withForm } from 'decorators/withForm'

const statusOptions = Object.entries({
  accepted: 'Accepted',
  rejected: 'Rejected',
  pending: 'Pending',
}).map(([value, label]) => ({ value, label }))

const DataChangeRequestFilters = () => (
  <Grid container spacing={2} style={{ width: '100%' }} sx={{ justifyContent: 'flex-end' }}>
    <Grid style={{ width: 200 }}>
      <FormTextField label="Search..." name="search" />
    </Grid>
    <Grid style={{ width: 200 }}>
      <FormSelect label="Status" name="status" options={statusOptions} />
    </Grid>
  </Grid>
)

// Only this form's own fields: `type` is owned by the tabs, and initialValues would feed a stale copy back.
export default withForm({
  form: 'dataChangeRequestFilters',
  onChange: debounce(
    (values: any, _dispatch: any, props: any) => props.setFilters(pick(values, ['status', 'search'])),
    500,
  ),
})(DataChangeRequestFilters)
